"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = void 0;
const tslib_1 = require("tslib");
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const checked_1 = (0, tslib_1.__importDefault)(require("./svgs/checked"));
const indeterminate_1 = (0, tslib_1.__importDefault)(require("./svgs/indeterminate"));
exports.StyledLabel = styled_components_1.default.label `
  font-family: PFDINText;
  font-size: 9pt;
  display: flex;
  align-items: center;
  font-weight: ${({ checked }) => (checked ? `500` : `normal`)};
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};

  [data-reach-custom-checkbox-input] {
    width: 1rem;
    height: 1rem;
    border-radius: 2px;
    background-color: ${theme_1.colors.white};
    border: 0.5px solid ${theme_1.colors.black};
    appearance: none;
    margin: 0 8px 0 0;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }

  > [data-reach-custom-checkbox][data-state='checked'] {
    > [data-reach-custom-checkbox-input] {
      background: ${theme_1.colors.black};
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(${checked_1.default});
    }
  }

  > [data-reach-custom-checkbox][data-state='mixed'] {
    > [data-reach-custom-checkbox-input] {
      background: ${theme_1.colors.black};
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(${indeterminate_1.default});
    }
  }
`;
